import "@/App.css";
import { Toaster } from "sonner";
import { Navbar } from "@/components/landing/Navbar";
import { Hero } from "@/components/landing/Hero";
import { About } from "@/components/landing/About";
import { Services } from "@/components/landing/Services";
import { Projects } from "@/components/landing/Projects";
import { MirfieldShowcase } from "@/components/landing/MirfieldShowcase";
import { Testimonials } from "@/components/landing/Testimonials";
import { QuoteForm } from "@/components/landing/QuoteForm";
import { Footer } from "@/components/landing/Footer";
import { FloatingCall } from "@/components/landing/FloatingCall";

function App() {
  return (
    <div className="App font-body antialiased">
      <Toaster position="top-center" richColors />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Projects />
        <MirfieldShowcase />
        <Testimonials />
        <QuoteForm />
      </main>
      <Footer />
      <FloatingCall />
    </div>
  );
}

export default App;
